import {
  type AiFieldCellLoadingState,
  useAiFieldCellLoadingState
} from '@databases/database-ai-fields';
import React, { type FunctionComponent, type ReactElement, useEffect } from 'react';

type AiSummaryProcessingBoundaryProps = {
  children: (loadingState: AiFieldCellLoadingState) => ReactElement;
  contentId: string;
  entryId: string;
  fieldId: string;
  isEnabled: boolean;
  isTargetValueEmpty: boolean;
  onProcessingStart: () => void;
};

const AiSummaryProcessingSubscriber: FunctionComponent<
  Omit<AiSummaryProcessingBoundaryProps, 'isEnabled'>
> = ({
  children,
  contentId,
  entryId,
  fieldId,
  isTargetValueEmpty,
  onProcessingStart
}) => {
  const loadingState = useAiFieldCellLoadingState({
    contentId,
    aiFieldType: 'summary',
    entryId,
    fieldId,
    isTargetValueEmpty
  });
  const isProcessing = loadingState !== null;

  useEffect(() => {
    if (isProcessing) {
      onProcessingStart();
    }
  }, [isProcessing, onProcessingStart]);

  return children(loadingState);
};

export const AiSummaryProcessingBoundary: FunctionComponent<
  AiSummaryProcessingBoundaryProps
> = ({ isEnabled, ...props }) =>
  isEnabled ? <AiSummaryProcessingSubscriber {...props} /> : props.children(null);
